export default function CaseStudies() {
  return (
    <section id="cases" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-bar-chart-line"></i>
            Измеримые результаты
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Кейсы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Примеры из практики. Во всех проектах большое внимание уделялось именно качеству коммуникации сотрудников с клиентами — и это принесло измеримый бизнес-результат.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20international%20logistics%20company%20office%20interior%20with%20professional%20customer%20service%20team%20at%20work%20warm%20natural%20light%20clean%20organized%20workspace%20welcoming%20atmosphere%20corporate%20design&width=200&height=200&seq=client-logistics-case&orientation=squarish"
                  alt="Международная логистическая компания"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 1</div>
                <h3 className="text-lg font-bold text-gray-900">Международная логистическая компания</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              Команда работала профессионально, но общение с клиентами было сухим и формальным. После обучения коммуникации, активному слушанию и работе с ожиданиями — клиенты стали возвращаться чаще.
            </p>
            <div className="flex flex-wrap gap-2 mb-5">
              {['Диагностика', 'Тренинг', 'Сопровождение', 'Разбор коммуникаций'].map((tag, i) => (
                <span key={i} className="bg-teal-50 text-teal-700 text-xs px-3 py-1.5 rounded-full font-medium border border-teal-100">{tag}</span>
              ))}
            </div>
            <div className="bg-teal-600/10 rounded-xl p-4 text-center">
              <div className="text-3xl font-extrabold text-teal-600 mb-1">18–23%</div>
              <div className="text-sm text-gray-600">рост конверсии после изменения подхода к коммуникации</div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20luxury%20concierge%20service%20office%20interior%20with%20professional%20assistants%20providing%20premium%20client%20support%20elegant%20atmosphere%20warm%20lighting%20high-end%20corporate%20environment%20with%20satisfied%20clients&width=200&height=200&seq=client-concierge-case&orientation=squarish"
                  alt="Консьерж сервис"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 2</div>
                <h3 className="text-lg font-bold text-gray-900">Консьерж сервис</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              Обучение переговорам, работе с ценностью и коммуникации с требовательными клиентами. Сотрудники научились аргументировать стоимость услуги и выстраивать доверительные отношения.
            </p>
            <div className="flex flex-wrap gap-2 mb-5">
              {['Тренинг', 'Переговоры', 'Работа с ценностью', 'Сопровождение'].map((tag, i) => (
                <span key={i} className="bg-teal-50 text-teal-700 text-xs px-3 py-1.5 rounded-full font-medium border border-teal-100">{tag}</span>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-teal-600/10 rounded-xl p-3 text-center">
                <div className="text-2xl font-extrabold text-teal-600 mb-0.5">64→84%</div>
                <div className="text-xs text-gray-600">рост продлений</div>
              </div>
              <div className="bg-teal-600/10 rounded-xl p-3 text-center">
                <div className="text-2xl font-extrabold text-teal-600 mb-0.5">+Чек</div>
                <div className="text-xs text-gray-600">рост среднего чека</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20ecommerce%20company%20office%20interior%20with%20customer%20support%20team%20working%20at%20computers%20warm%20natural%20light%20professional%20yet%20welcoming%20atmosphere%20clean%20design%20plants%20on%20desks%20collaborative%20space&width=200&height=200&seq=client-ecom-case&orientation=squarish"
                  alt="B2C компания"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 3</div>
                <h3 className="text-lg font-bold text-gray-900">B2C компания</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              После серии тренингов и сопровождения отдела продаж с фокусом на качество коммуникации, работу с ценностью и аргументацией.
            </p>
            <div className="flex flex-wrap gap-2 mb-5">
              {['Серия тренингов', 'Сопровождение', 'Работа с ценностью', 'Аргументация'].map((tag, i) => (
                <span key={i} className="bg-teal-50 text-teal-700 text-xs px-3 py-1.5 rounded-full font-medium border border-teal-100">{tag}</span>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-teal-600/10 rounded-xl p-3 text-center">
                <div className="text-2xl font-extrabold text-teal-600 mb-0.5">+55%</div>
                <div className="text-xs text-gray-600">рост конверсии</div>
              </div>
              <div className="bg-teal-600/10 rounded-xl p-3 text-center">
                <div className="text-2xl font-extrabold text-teal-600 mb-0.5">+116 000 $</div>
                <div className="text-xs text-gray-600">рост валовой прибыли</div>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mt-12 text-center">
          <div className="bg-teal-600/5 rounded-2xl p-6 border border-teal-100">
            <p className="text-base text-gray-700 leading-relaxed">
              <strong className="text-teal-700">Общий знаменатель всех проектов — фокус на качестве коммуникации.</strong> Когда сотрудники учатся слышать клиента, выявлять потребности, аргументировать ценность и сопровождать после сделки — растут и конверсия, и средний чек, и количество повторных обращений.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}